
import React from 'react';
import {FormHelper} from '../../../dist/src/index';
import {Button} from 'react-toolbox/lib/button';
import {Input} from 'react-toolbox/lib/input';


const store = {}
export const attributes = {"title":"Controlled"};
export default class extends React.Component {
  constructor() {
    super()
    this.state = {}
  }
  render() {
    return (
      <div>
        {(store.example = <FormHelper
  inputComponent={Input}
  onSave={credentials => this.setState({credentials})}
  onChange={credentials => this.setState({credentials})}
  value={this.state.credentials}
  fields={[
    {path: ['email'], icon: 'email', label: 'Email'},
  ]}
/>
, null)}<h4>Controlled</h4>
<p>The form can be made into an controlled component by passing an
onChange function. This can be useful if you have an more advanced
use case and for examples use multiple forms, need to react to changes
while they are beeing typed or similar.
In this case you don't need a saveButton, but you will still need to
pass an onSave function as that will be called when the user submits
the form in other ways, with the keyboard for example.</p>
<h6>Code</h6>

    <div className="example">
      <div className="source">
        <pre><code className="language-jsx">
          <span className="token tag"><span className="token tag"><span className="token punctuation">&lt;</span>FormHelper</span>{"\n"}  <span className="token attr-name">inputComponent</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span>Input<span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">onSave</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span>credentials <span className="token operator">=</span><span className="token operator">></span> <span className="token keyword">this</span><span className="token punctuation">.</span><span className="token function">setState</span><span className="token punctuation">(</span><span className="token punctuation">{"{"}</span>credentials<span className="token punctuation">{"}"}</span><span className="token punctuation">)</span><span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">onChange</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span>credentials <span className="token operator">=</span><span className="token operator">></span> <span className="token keyword">this</span><span className="token punctuation">.</span><span className="token function">setState</span><span className="token punctuation">(</span><span className="token punctuation">{"{"}</span>credentials<span className="token punctuation">{"}"}</span><span className="token punctuation">)</span><span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">value</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span><span className="token keyword">this</span><span className="token punctuation">.</span>state<span className="token punctuation">.</span>credentials<span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">fields</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span><span className="token punctuation">[</span>{"\n"}    <span className="token punctuation">{"{"}</span>path<span className="token punctuation">:</span> <span className="token punctuation">[</span><span className="token string">'email'</span><span className="token punctuation">]</span><span className="token punctuation">,</span> icon<span className="token punctuation">:</span> <span className="token string">'email'</span><span className="token punctuation">,</span> label<span className="token punctuation">:</span> <span className="token string">'Email'</span><span className="token punctuation">{"}"}</span><span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">]</span><span className="token punctuation">{"}"}</span></span>{"\n"}<span className="token punctuation">/></span></span>{"\n"}
        </code></pre>
      </div>
    </div><h6>Demo</h6>

    <div className="example">
      <div className="run"><div>
  {store.example}
</div>
</div>
    </div>
  <h6>State</h6>

    <div className="example">
      <div className="run"><div>
  <p>
    Credentials: {JSON.stringify(this.state.credentials)}
  </p>
</div>
</div>
    </div>
  
      </div>
    );
  }
};


/** WEBPACK FOOTER **
 ** ./docs/pages/Examples/05-controlled.md
 **/